
var  { jwtDecode } = require('jwt-decode');

export const decode =  function(token) {
    try {
        var decoded = jwtDecode(token);
        //console.log('decoded : ' + JSON.stringify(decoded));
        return decoded;
    } catch (error) {
        console.log('jwt decode error => ', error);
        return null;
    }
}

